import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';
import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import topLogo from 'assets/images/top-logo.svg';
import ImageIconButton from 'components/cmn/ImageIconButton';

interface BoxProps extends MuiBoxProps {
  open?: boolean;
}
interface IDrawerHeaderProps {
  open: boolean;
}
const DrawerHeaderBox = styled(MuiBox, { shouldForwardProp: prop => prop !== 'open' })<BoxProps>(({ theme, open }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: open ? 'flex-start' : 'center',
  paddingLeft: theme.spacing(open ? 3 : 0),
  backgroundColor: theme.palette.mind.custom.white,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

function DrawerHeader({ open }: IDrawerHeaderProps): JSX.Element {
  return (
    <DrawerHeaderBox open={open}>
      <Stack direction="row" alignItems="center" sx={{ typography: 'subtitle1', fontWeight: 800 }}>
        <ImageIconButton id="logo" alt="mind-code" src={topLogo} sx={{ width: 'auto', height: 'auto' }} />
      </Stack>
    </DrawerHeaderBox>
  );
}

export default DrawerHeader;
